import { Pagination } from '@/services/request/request.types';
import { AxiosResponse, AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

const getPaginationHeaders = (
  axiosHeaders: RawAxiosResponseHeaders | AxiosResponseHeaders
): Pagination => {
  return {
    totalPages: Number(axiosHeaders['total-pages']) || 0,
    currentPage: Number(axiosHeaders['current-page']) || 0,
    pageItems: Number(axiosHeaders['page-items']) || 0,
    totalCount: Number(axiosHeaders['total-count']) || 0,
  };
};

export const paginationResponseTransformer = <T extends { pagination: Pagination }>(
  response: AxiosResponse
): T => {
  return { ...response.data, pagination: getPaginationHeaders(response.headers) };
};
